import type {
  FilterOption,
  SlugData,
  Technology,
} from '@indutrust/shared-model';

function mapSlugChildren(children: SlugData[] | undefined): FilterOption[] {
  return (children ?? []).map((child) => ({
    id: child.id,
    name: child.name,
  }));
}

/** Maps technologies (with capability leaves) to hierarchical filter options. */
export function mapTechnologiesToFilterOptions(
  technologies: readonly (Pick<Technology, 'id' | 'name'> & {
    capabilities?: Technology['capabilities'];
  })[]
): FilterOption[] {
  return technologies.map((technology) => ({
    id: technology.id,
    name: technology.name,
    children: mapSlugChildren(technology.capabilities),
  }));
}

/** Maps id/name entities to flat filter options. */
export function mapIdNameToFilterOptions(
  entities: readonly { id: number; name: string }[]
): FilterOption[] {
  return entities.map((entity) => ({
    id: entity.id,
    name: entity.name,
  }));
}

/** Maps industrial areas to flat filter options. */
export function mapIndustrialAreasToFilterOptions(
  areas: readonly { id: number; name: string }[]
): FilterOption[] {
  return mapIdNameToFilterOptions(areas);
}

/** Maps regions (emirates) to flat filter options. */
export function mapRegionsToFilterOptions(
  regions: readonly { id: number; name: string }[]
): FilterOption[] {
  return mapIdNameToFilterOptions(regions);
}
